import { AlertScale } from './domain/AlertScale';
import type { EvaluationRule, EvaluationRules } from './evaluation/EvaluationRule';

export function createNextEvaluationRules(): EvaluationRules {
  const rules: EvaluationRule[] = [
    // Load flow calculations - Energy Consumers
    {
      calculationProperty: 'Lv_EnergyConsumer_VoltageDiffTransformerEndPercent',
      value: AlertScale.fromWarningVectors([-10, -10], [10, 10])
    },
    {
      calculationProperty: 'Mv_EnergyConsumer_VoltageDiffTransformerEndPercent',
      value: AlertScale.fromWarningVectors([-10, -10], [10, 10])
    },
    
    // Load flow calculations - ACLineSegments
    {
      calculationProperty: 'Lv_AcLineSegment_LoadingPercent',
      value: AlertScale.fromWarningVectors([0, 0], [80, 100])
    },
    {
      calculationProperty: 'Mv_AcLineSegment_LoadingPercent',
      value: AlertScale.fromWarningVectors([0, 0], [80, 100])
    },
    
    // Load flow calculations - PowerTransformers
    {
      calculationProperty: 'Lv_PowerTransformer_LoadingPercent',
      value: AlertScale.fromWarningVectors([0, 0], [80, 100])
    },
    {
      calculationProperty: 'Mv_PowerTransformer_LoadingPercent',
      value: AlertScale.fromWarningVectors([0, 0], [80, 100])
    },
    
    // Load flow calculations - MV Busbar
    {
      calculationProperty: 'Mv_Busbar_VoltageDiffTransformerEndPercent',
      value: AlertScale.fromWarningVectors([-10, -10], [10, 10])
    },
    
    // Phase voltage thresholds - LV
    {
      calculationProperty: 'Lv_Phase1Min',
      value: AlertScale.fromWarningVectors([300, 1000], [Infinity, Infinity])
    },
    {
      calculationProperty: 'Lv_Phase1Max',
      value: AlertScale.fromWarningVectors([300, 1000], [Infinity, Infinity])
    },
    {
      calculationProperty: 'Lv_Phase2Min',
      value: AlertScale.fromWarningVectors([300, 1000], [Infinity, Infinity])
    },
    {
      calculationProperty: 'Lv_Phase3Max',
      value: AlertScale.fromWarningVectors([300, 1000], [Infinity, Infinity])
    },
    
    // Phase voltage thresholds - MV
    {
      calculationProperty: 'Mv_Phase1Min',
      value: AlertScale.fromWarningVectors([1000, 25000], [Infinity, Infinity])
    },
    {
      calculationProperty: 'Mv_Phase1Max',
      value: AlertScale.fromWarningVectors([1000, 25000], [Infinity, Infinity])
    },
    {
      calculationProperty: 'Mv_Phase2Min',
      value: AlertScale.fromWarningVectors([1000, 25000], [Infinity, Infinity])
    },
    {
      calculationProperty: 'Mv_Phase3Max',
      value: AlertScale.fromWarningVectors([1000, 25000], [Infinity, Infinity])
    }
  ];
  return {
    type: 'AVAILABLE',
    rules
  };
}
